import React, { useState } from 'react';

import manImg from '../../assets/google-spot-landing/2min-hero-img.png';
import fibeLogo from '../../assets/google-spot-landing/fibeLogo.svg';
import offerImg from '../../assets/google-spot-landing/offerImg.png';
import offerImgNew from '../../assets/google-spot-landing/offerImgNew.png';
import handImg from '../../assets/google-spot-landing/instant-cash.png';

import { useNavigate } from 'react-router-dom';
import {
  invokeGpayPhoneSpotAPI,
  invokeGpayIdentitySpotAPI,
  invokeGpayLocationSpotAPI,
} from '../../google-spot';
import { FullScreenBackdropLoader } from '../../fibe-ui';
import { invokeGpayMediaSpotAPI } from '../../google-spot/gpay-upload-api';
import { SecureClient } from '../../utils';
import { useAuthStore } from '../../redux';
import { useDispatch } from 'react-redux';
import { clearState } from '../../redux/features/postPanJourneySlice';
import Event from '../../utils/eventTracker';
import Attribute from '../../utils/MoengageAttributes';

const FibeExperienceParentComponent = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { customerId, customerRefNum, Authorization, updateCustomerCred } =
    useAuthStore();

  const [isLoading, setIsLoading] = useState(false);
  const [isCheckboxError, setIsCheckboxError] = useState(false);
  const [isCheckboxChecked, setIsCheckboxChecked] = useState(true);

  const tncCheckboxHandler = (e) => {
    setIsCheckboxChecked(e.target.checked);
    setIsCheckboxError(false);
  };

  const goToSignUpPage = async () => {
    // DOCS: Call the Gpay API's get the data
    const gpayAPIsResponse = await callGPayAPIs();
    console.log('gpayAPIsResponse: ', gpayAPIsResponse);

    const { phone_number, email } = gpayAPIsResponse;
    if (phone_number && email) {
      // DOCS: Create the customer/ Login if existing customer
      createCustomerAPICall(gpayAPIsResponse);
    } else {
      navigate('/SignUp?utm_source=GOOGLE_SPOT&sourceId=GOOGLE_SPOT');
    }
  };

  const goToPrivacyPolicy = () => {
    microapps.openUrl({
      url: 'https://www.fibe.in/privacy-policy/?src=mobile',
    });
  };

  const callGPayAPIs = async () => {
    let responseToReturn = {};
    setIsLoading(true);
    const locationResponse = await invokeGpayLocationSpotAPI();
    setIsLoading(false);

    console.log('locationResponse: ', locationResponse);
    if (locationResponse.statusCode === 200) {
      responseToReturn = { ...responseToReturn, ...locationResponse.body };
    }

    setIsLoading(true);
    const identityResponse = await invokeGpayIdentitySpotAPI();
    setIsLoading(false);

    console.log('identityResponse: ', identityResponse);
    if (identityResponse.statusCode === 200) {
      responseToReturn = { ...responseToReturn, ...identityResponse.body };
    }

    if (identityResponse.statusCode === 200) {
      // DOCS: User has given the consent to share the data, Update the redux store with the data
      console.log('Got the identity api response');
      // setFirstName(identityResponse.body.given_name);
      // setLastName(identityResponse.body.family_name);
      // setEmail(identityResponse.body.email);
      // updateProfile();
    } else {
      console.log('Identity api denied the request');

      // Router.push('/portal?utm_source=GOOGLE_SPOT&sourceId=GOOGLE_SPOT');
    }

    setIsLoading(true);
    const phoneAPIResponse = await invokeGpayPhoneSpotAPI();
    setIsLoading(false);

    console.log('phoneAPIResponse: ', phoneAPIResponse);
    if (phoneAPIResponse.statusCode === 200) {
      responseToReturn = { ...responseToReturn, ...phoneAPIResponse.body };
    }

    if (phoneAPIResponse.statusCode === 200) {
      // setMobile(phoneAPIResponse.body.phone_number);
      // updateProfile();
      // Router.push('/SignUp?utm_source=GOOGLE_SPOT&sourceId=GOOGLE_SPOT');
    } else {
      // Router.push('/portal?utm_source=GOOGLE_SPOT&sourceId=GOOGLE_SPOT');
    }

    return responseToReturn;
  };

  const getCashNowButtonClicked = async () => {
    // DOCS: Call the Gpay API's get the data
    const gpayAPIsResponse = await callGPayAPIs();
    console.log('gpayAPIsResponse: ', gpayAPIsResponse);

    // DOCS: Create the customer
    createCustomerAPICall(gpayAPIsResponse);
  };

  const testUploadAPI = async () => {
    const res = await invokeGpayMediaSpotAPI(
      'application/pdf',
      'back',
      'files'
    );
    console.log('testUploadAPI -> res', res);
  };

  const testBackCamAPI = async () => {
    const res = await invokeGpayMediaSpotAPI('image/jpeg', 'back', 'camera');
    console.log('testUploadAPI -> res', res);
  };

  const testFrontCamAPI = async () => {
    const res = await invokeGpayMediaSpotAPI('image/jpeg', 'front', 'camera');
    console.log('testUploadAPI -> res', res);
  };

  const createCustomerAPICall = (gpayAPIsResponse) => {
    console.log(
      '[API] createCustomerAPICall gpayAPIsResponse: ',
      gpayAPIsResponse
    );
    const { phone_number, email } = gpayAPIsResponse;

    let mobileNumberFormatted = phone_number;

    // DOCS: If phone no is not there just redirect to SignUp
    if (!phone_number) {
      navigate('/SignUp?utm_source=GOOGLE_SPOT&sourceId=GOOGLE_SPOT');
      return;
    }
    try {
      mobileNumberFormatted = phone_number.split(' ')[1];
      Attribute('mobile', parseInt(mobileNumberFormatted));
    } catch (e) {
      mobileNumberFormatted = phone_number;
      console.log('mobileNumberFormatted Exception: ', e);
    }

    const createCustomerPayload = {
      source: 'WEB',
      mobileNumber: parseInt(mobileNumberFormatted),
      email,
      templateType: 'GOOGLE_SPOT',
      utmResource: 'GOOGLE_SPOT',
      sourceName: 'GOOGLE_SPOT',
      otpCode: '000000',
      additionalFields: JSON.stringify({
        ...gpayAPIsResponse,
      }),
      // DOCS: below query-params fields will not be there in the payload
      // campaignId,
      // adGroupId,
      // utmTerm,
      // deviceType: device,
      // medium,
    };

    setIsLoading(true);
    SecureClient({
      otherPayloadDetailsPresent: true,
      isEncrypted: true,
      customerId: null,
      route: 'customeronboarding/createcustomer',
      payload: createCustomerPayload,
      method: 'POST',
      successFn: (res) => {
        const { statusCode, body } = res;
        if (statusCode === 200) {
          const {
            customerId,
            customerRefNum,
            token: Authorization,
            isSocialLoginNeeded,
            showReferralScreen,
          } = res.body;
          Event('Web_Signup');
          Event(customerId);
          // console.log('showReferralScreen: ', showReferralScreen);

          onBoardCustomerToDashboard({
            customerId,
            customerRefNum,
            Authorization,
          });
          // console.log('isSocialLoginNeeded: ', isSocialLoginNeeded);
          if (isSocialLoginNeeded) {
            window.location.href = `${
              window.location.origin
            }/SignUp?utm_source=GOOGLE_SPOT&sourceId=GOOGLE_SPOT&email=${email}&isEmailPresent=${
              email != ''
            }`;
          } else {
            Attribute('email', email);
            // console.log('isSocialLoginNeeded else part');
            // console.log('showReferralScreen: ', showReferralScreen);

            if (showReferralScreen) {
              navigate('/pre-pan');
            } else {
              navigate('/dashboard');
            }
          }
        } else {
          console.log('[Error] createCustomerAPICall: ', res);
          navigate('/SignUp?utm_source=GOOGLE_SPOT&sourceId=GOOGLE_SPOT');
        }
      },
      errorFn: (err) => {
        console.log('[Error] createCustomerAPICall: ', err);
        navigate('/SignUp?utm_source=GOOGLE_SPOT&sourceId=GOOGLE_SPOT');
      },
      finallyFn: () => {
        setIsLoading(false);
      },
    });
  };

  const onBoardCustomerToDashboard = ({
    customerId,
    customerRefNum,
    Authorization,
  }) => {
    // DOCS: Clear the old state
    (async () => {
      await dispatch(clearState());
    })();

    // DOCS: Set the new state
    updateCustomerCred({
      customerId,
      customerRefNum,
      Authorization,
    });

    // DOCS: Navigate to dashboard
    // navigate('/dashboard');
  };

  const applyNowClickHandler = async () => {
    console.log('Apply now clicked -> applyNowClickHandler');

    // DOCS: check the tnc checkbox
    if (!isCheckboxChecked) {
      setIsCheckboxError(true);
      return;
    }

    // DOCS: Call the Gpay API's get the data
    const gpayAPIsResponse = await callGPayAPIs();
    console.log('gpayAPIsResponse: ', gpayAPIsResponse);

    // DOCS: Create the customer
    createCustomerAPICall(gpayAPIsResponse);
  };

  const openUrlInWindow = (url) => () => {
    microapps.openUrl({
      url,
    });
  };

  return (
    <>
      <FullScreenBackdropLoader isLoading={isLoading} />
      <div className="flex flex-row justify-between items-center banner-background px-3">
        <div className="flex-1 max-w-[60%]">
          {/* <div>
              <img src={fibeLogo} alt="fibeLogo" />
            </div> */}
          <div className="my-2">
            <h1 className="mb-1 text-[#434343] font-['Gilroy'] text-[17px] font-semibold leading-7">
              Get up to <span className="text-[20px] font-bold">₹5 lacs</span>
            </h1>
            <p className="text-text-primary text-lg">in just 2 minutes</p>
          </div>
          <button
            onClick={getCashNowButtonClicked}
            className="bg-accent text-white text-center rounded-md text-sm mt-1 flex-shrink-0 w-[116px] h-[43px]"
          >
            Get Cash Now
          </button>
        </div>
        <div className="h-190px overflow-hidden flex-shrink-0 mt-8">
          <img src={manImg} alt="manImg" />
        </div>
      </div>
      <div className="p-3">
        <div className="mt-4 mb-7 text-center">
          <img
            className="inline-block w-full"
            src={offerImgNew}
            alt="offerImg"
          />
        </div>

        <div className="relative rounded-md border border-stroke p-4 bg-[#FFF9F0] overflow-hidden">
          <div className="relative z-10">
            <h2 className="text-text-primary text-lg mb-3">
              Instant Cash for salaried professionals
            </h2>
            <ul className="!list-inside list-disc mt-3">
              <li className="text-xs text-text-primary mb-3">
                Loans up to ₹ 5 lacs
              </li>
              <li className="text-xs text-text-primary mb-3">
                Repay in 3-24 months
              </li>
              <li className="text-xs text-text-primary mb-3">
                No pre-closure charges
              </li>
              <li className="text-xs text-text-primary mb-3">
                Minimal documentation
              </li>
            </ul>
          </div>

          <div className="absolute bottom-0 right-0 z-0 opacity-80">
            <img src={handImg} alt="handImg" className="w-28 md:w-28" />
          </div>
        </div>

        <div className="mt-5 mb-8">
          <h3 className="text-text-dark text-xl mb-3">Eligibility criteria</h3>
          <p className="text-xs text-text-primary mb-3">
            <span className="text-text-dark text-sm">Age : </span>21 to 55 years
          </p>
          <p className="text-xs text-text-primary">
            <span className="text-text-dark text-sm">Minimum salary : </span>
            Metro - ₹18,000 / Non-metro - ₹15,000
          </p>
        </div>

        <div className="flex mb-1">
          <label className="iTrCheckBox !text-sm text-text-primary">
            <input
              checked={isCheckboxChecked}
              onChange={tncCheckboxHandler}
              type="checkbox"
              className="bg-red-100 w-[50px] border-red-300 text-red-500 focus:ring-red-200 align-top mx-3"
            />
            <span className="mt-1 iTrCheckmark iTrCheckmarkOkyc"></span>
          </label>
          <label className="text-text-primary text-xs">
            Accepting our{' '}
            <span
              onClick={openUrlInWindow(
                'https://portal-ec2.fibe.in/privacy-policy?src=mobile'
              )}
              className="text-accent underline"
            >
              Privacy Policies
            </span>{' '}
            and{' '}
            <span
              onClick={openUrlInWindow(
                'https://portal-ec2.fibe.in/terms-and-conditions?src=mobile'
              )}
              className="text-accent underline"
            >
              T&C
            </span>
            . Also authorizing Fibe to{' '}
            <span
              onClick={openUrlInWindow('https://dms.fibe.in/freecredit-terms')}
              className="text-accent underline"
            >
              retrieve your credit report
            </span>{' '}
            & communicate with you via Phone, E-mails, WhatsApp etc
          </label>
        </div>
        <div className="flex mb-6 ml-8">
          {isCheckboxError ? (
            <span className="text-xs text-[#FF3E79] flex flex-row items-center mr-auto pt-1 mb-2 ">
              Accept Terms & Conditions
            </span>
          ) : (
            ''
          )}
        </div>
        <button
          onClick={applyNowClickHandler}
          className="bg-accent text-white text-center rounded-md py-3 w-full text-sm mt-1"
        >
          Apply Now
        </button>

        {/* <button
          onClick={testUploadAPI}
          className="bg-accent text-white text-center rounded-md py-3 w-full text-sm mt-1"
        >
          Test upload API
        </button> */}

        {/* <button
          onClick={() => navigate('/dashboard')}
          className="bg-accent text-white text-center rounded-md py-3 w-full text-sm mt-1"
        >
          Move To Dashboard
        </button> */}

        {/* <div className="flex gap-4 justify-center items-center">
          <button
            onClick={testBackCamAPI}
            className="bg-accent text-white text-center rounded-md py-3 w-full text-sm mt-1"
          >
            Test BackCam
          </button>
          <button
            onClick={testFrontCamAPI}
            className="bg-accent text-white text-center rounded-md py-3 w-full text-sm mt-1"
          >
            Test FrontCam
          </button>
        </div> */}

        <div className="text-center my-4">
          <div className={`flex flex-row w-full justify-center`}>
            <div className="text-text-primary text-xs flex flex-row mx-auto">
              Already have an account,{' '}
              <p onClick={goToSignUpPage}>
                <span className="text-accent underline text-sm">
                  {` `}Sign in
                </span>
              </p>
            </div>
          </div>
          <span className="mt-2" onClick={goToPrivacyPolicy}>
            {/* <p>
              <span className="text-accent underline text-sm">
                Privacy Policy
              </span>
            </p> */}
          </span>
        </div>
      </div>
    </>
  );
};

export default FibeExperienceParentComponent;
